<script>
	import Map from './Map.svelte';
</script>

<Map lat={60.45} lon={22.27} zoom={11}>
</Map>